import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PetImageB"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.25 15.75H15.75V18H14.25V15.75ZM14.25 0H15.75V2.25H14.25V0ZM6 8.25H8.25V9.75H6V8.25ZM21.75 8.25H24V9.75H21.75V8.25ZM8.1119 3.16202L9.1619 2.11202L10.7534 3.70202L9.7034 4.75277L8.1119 3.16202ZM19.2586 14.292L20.3086 13.242L21.8993 14.8327L20.8493 15.8827L19.2586 14.292ZM8.12021 14.8297L9.71096 13.239L10.761 14.289L9.17096 15.8797L8.12021 14.8297ZM19.2503 3.69451L20.8418 2.10301L21.8918 3.15301L20.3003 4.74451L19.2503 3.69451ZM15 3.75C12.1005 3.75 9.75 6.1005 9.75 9C9.75 11.8995 12.1005 14.25 15 14.25C17.8995 14.25 20.25 11.8995 20.25 9C20.25 6.1005 17.8995 3.75 15 3.75ZM15 12.75C12.9289 12.75 11.25 11.0711 11.25 9C11.25 6.92893 12.9289 5.25 15 5.25V12.75ZM3.75 13.5H0V24H3.75C4.99264 24 6 22.9926 6 21.75V20.25C5.99669 19.695 5.78834 19.1607 5.415 18.75C5.78834 18.3393 5.99669 17.805 6 17.25V15.75C6 14.5074 4.99264 13.5 3.75 13.5ZM1.5 15H3.75C4.16421 15 4.5 15.3358 4.5 15.75V17.25C4.5 17.6642 4.16421 18 3.75 18H1.5V15ZM4.5 21.75C4.5 22.1642 4.16421 22.5 3.75 22.5H1.5V19.5H3.75C4.16421 19.5 4.5 19.8358 4.5 20.25V21.75ZM1.5 1.5H6.75V0H0V6.75H1.5V1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PetImageB.vue"]]);
